
import React from 'react'
import { Container, Tabs, Tab, Button } from 'react-bootstrap'
import { FAQ_COLLECTION } from '../../firebase'
import { useHistory, useParams } from 'react-router';

const DeleteFaq = () => {

    const { id } = useParams()

    const history = useHistory()

    const handleDelete = () => {
        FAQ_COLLECTION.doc(id).delete()
            .then(() => {
                alert("Uspješno obrisano 👍")
                history.push('/preview-faq')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="delete-faq" className="mb-3" transition={false}>
                    <Tab eventKey="preview-faq" title={<div onClick={() => history.push('/preview-faq')}>Pregled faq</div>} />
                    <Tab eventKey="add-faq" title={<div onClick={() => history.push('/add-faq')}>Dodaj</div>} />
                    <Tab eventKey="edit-faq" title='Uredi' disabled />
                    <Tab eventKey="delete-faq" title='Obriši'>
                        <Button variant="danger" onClick={handleDelete}>Obriši</Button>
                    </Tab>
                </Tabs>
            </Container>
        </>
    )
}

export default DeleteFaq
